<template>
  <div class="regions">
    <h1>Coach Tour Regions</h1>
    <Regions />
  </div>
</template>

<script>
import Regions from '@/components/RegionsFields.vue'
export default {
  name: 'regions-index',
  components: {
    Regions,
    // PickupPoints
  },
}
</script>
